var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('enterprise-edit-print-advertising',{ref:"editAds",on:{"ads:changed":_vm.submitPrintAdvertising}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }